import React, { useState, useEffect } from "react";
import Loader from "../../Components/Loader";
import { useNavigate } from "react-router-dom";

const  ExhaustedPopup = ({
    isOpen,
    imageUrl = "https://jobcritics.com/assets/img/biar/walletEmpty.webp",
    loaderDuration = 1000,
    onClose,
    onConfirm,
}) => {
    // Move hooks to the top level
    const [showLoader, setShowLoader] = useState(true);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (isOpen) {
            document.documentElement.style.overflow = "hidden";
            document.body.style.overflow = "hidden";

            setShowLoader(true);
            const timer = setTimeout(() => {
                setShowLoader(false);
            }, loaderDuration);

            return () => {
                clearTimeout(timer);
                document.documentElement.style.overflow = "auto";
                document.body.style.overflow = "auto";
            };
        }
    }, [isOpen, loaderDuration]);

    // Early return after hooks
    if (!isOpen) return null;


    const handleCancl = () => {
        onClose();
    };
    const handleContact = () => {
        navigate("/contact_us");
    };

    return (
        <div
            className="fixed inset-0 flex items-center justify-center bg-[#000000bf] bg-opacity-50 z-50"
            role="dialog"
            aria-modal="true"
        >
            {showLoader ? (
                <Loader />
            ) : (
                <div className="bg-white p-[15px] pt-[25px] rounded-[27px] shadow-xl w-[22%] md:w-[50%] sm:w-[91%] relative flex flex-col items-center">
                    <p className="text-gray-600 text-center flex items-center justify-center p-[1px]">
                        <img
                            src={imageUrl}
                            alt="Expired"
                            className="w-[150px] mr-2"
                        />
                    </p>
                    <h6 className="font-semibold text-black text-center w-full mb-0 mt-[14px] pb-[5px]">
                     Credits Exhausted!
                    </h6>
                    <p className="text-gray-600 text-center text-[17px] leading-[1.6] pb-[15px]">
                    You’ve used all your available credits, so you can’t proceed with the verification of this candidate at the moment. Please contact us for assistance.
                    </p>
                    <div className="grid mt-[11px] w-full gap-3 justify-center">
                    <button
                            className="btn-explore-yellow text-c pd3 !w-[270px]"
                            aria-label="Close popup"
                            onClick={handleContact}
                            
                        >
                            Contact Us
                        </button>
                        <p
                            className="text-gray-700  hover:text-base hover:bg-gray-200 hover:rounded-[24px] cursor-pointer text-center text-c !p-[8px] !w-[300px] "
                            onClick={handleCancl}
                            aria-label="Close popup"
                        >
                            CLOSE
                        </p>
                       
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExhaustedPopup;